'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactNode } from 'react';
import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * Hover text on a line, a label, or a disabled control, reachable by keyboard too. `align` is the
 * trigger's edge the text lines up with. Pass the edge on the row's outer side, so the text stays
 * over the row.
 */
export function Explained(t0) {
  const $ = _c(19);
  let align;
  let children;
  let className;
  let spanProps;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      align,
      className,
      children,
      ...spanProps
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = children;
    $[3] = className;
    $[4] = spanProps;
    $[5] = text;
  } else {
    align = $[1];
    children = $[2];
    className = $[3];
    spanProps = $[4];
    text = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = `. ${text}`;
  let t3;
  if ($[8] !== t2) {
    t3 = <span className="sr-only">{t2}</span>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== spanProps || $[12] !== t1 || $[13] !== t3) {
    t4 = <span tabIndex={0} className={t1} {...spanProps}>{children}{t3}</span>;
    $[10] = children;
    $[11] = spanProps;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== align || $[16] !== t4 || $[17] !== text) {
    t5 = <BetterTooltip side="top" align={align} contentClassName="max-w-[220px] text-xs" content={text}>{t4}</BetterTooltip>;
    $[15] = align;
    $[16] = t4;
    $[17] = text;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}